import React, { useState } from 'react';
import { Badge, Dropdown, Nav, NavItem, Button } from 'react-bootstrap'
import { useNavigate } from "react-router-dom";
import LoginButton from "../../../components/buttons/login-button.js";
import LogoutButton from "../../../components/buttons/logout-button.js";
import { useAuth0 } from "@auth0/auth0-react";
import { apiGet, apiPut } from "../../../services/AuthService.js";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faBell,
  faCreditCard,
  faEnvelopeOpen,
  faFile,
  faMessage,
  faUser,
  faBuilding,
  faContactBook,
  faBookmark,
  faCompass,
  faFolder,
  faAddressBook,
  faClipboard
} from '@fortawesome/free-regular-svg-icons'
import {
    faChevronDown,
    faRibbon,
} from '@fortawesome/free-solid-svg-icons'
import {
  faGear, faLink, faPowerOff,
} from '@fortawesome/free-solid-svg-icons'


const ProfileDropdownItem = (props) => {
  const { icon, children } = props

  return (
    <>
      <FontAwesomeIcon className="me-2" icon={icon} fixedWidth />
      {children}
    </>
  )
}

const avatarStyle = {
    width: '36px',
    height: '36px',
    borderRadius: '50%',
    background: '#333333',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background 0.2s ease',
    cursor: 'pointer',
    flexShrink: 0,
};

export default function HeaderProfileNav(props) {

    //stateful properties (hooks)
    const { logout } = useAuth0();
    const navigate = useNavigate();
    const { accountProfile, setAccountProfile, toggleSidebarMd, setIsShowSidebarMd, logoutRedirectUrl, pillWidth } = props

    const [menuOpen, setMenuOpen] = useState(false);
    const rotated = document.getElementById("rotated");

    const { getAccessTokenSilently } = useAuth0();

    //handle menu item
    const handleMenuItemClick = async (navTarget) => {

        if (navTarget == 'logout') {
            // Call updatesetAccountProfileCurrentAccount on parent
            setAccountProfile(null);
            setIsShowSidebarMd(false);

            //remove external logout redirect url (for future calls only, after logout; this call will still use if specified)
            localStorage.removeItem('logoutRedirectUrl');

            //remove sessionData from local storage
            localStorage.removeItem('sessionData');

            //remove dataFileState from local storage
            localStorage.removeItem('dataFileState');

            //log out
            logout({
                logoutParams: {
                    returnTo: logoutRedirectUrl,
                },
            });
        } else if (navTarget == 'log-up') {
            handleCompanyChange("1");
        }
        else {
            //alert('/' + navTarget);
            navigate('/' + (navTarget == 'logout' ? '' : navTarget));
        }
    };

    //handle menu item
    const handleMenuClick = async () => {
        console.log("accountId: " + accountProfile.accountId + "\nhasImpersonate: " + accountProfile.hasImpersonate);

        setMenuOpen(!menuOpen);

        if (menuOpen) {
            rotated.style.transform = "rotate(0deg)";
        } else {
            rotated.style.transform = "rotate(180deg)";
        }
    };

    const handleCompanyChange = async (id) => {
        //const fieldName = event.target.name;
        const value = id;
        //console.log('Field: ' + fieldName + ', Value: ' + value);

        await getAccountSwitch(value)
            .then(response => {
                if (response.success) {
                    localStorage.removeItem('dataFileState');

                    //refresh site at admin dashboard page with new token
                    //window.location.href = window.location.origin + "?admindashboard";
                    //window.location.href = window.location.origin + "/admindashboard?refresh=true";
                    localStorage.setItem('admindashboard', 'admindashboard');
                    window.location.href = window.location.origin;
                    
                } else {

                }
            })
            .catch(ex => {
                //setPageStatus('error');
                //setPageErrors(ex.message);
            })
            .finally(response => {

            })
    };

    //get account switch
    const getAccountSwitch = async (accountId) => {
        //console.log('Switching Account...');

        const apiUrl = 'accounts/accountswitch/' + accountId;
        //console.log(apiUrl);

        const response = await apiGet(apiUrl, getAccessTokenSilently);
        const json = response.ok ? await response.json() : [];
        console.log('Response - Status: ' + response.status + ', Success: ' + response.ok + ', Json: ' + JSON.stringify(json));

        return { success: response.ok, data: json };
    };

    const pillRightPadding = 8; // matches Header.js pill padding-right
    const toggleRightPadding = 4; // Dropdown.Toggle px-1
    const skidding = pillRightPadding + toggleRightPadding;

    const dropdownMenuStyle = {
        background: '#ffffff',
        border: '1px solid #e5e7eb',
        borderRadius: '12px',
        boxShadow: '0 8px 24px rgba(0,0,0,0.18)',
        minWidth: pillWidth ? `${Math.round(pillWidth)}px` : '180px',
        width: pillWidth ? `${Math.round(pillWidth)}px` : undefined,
        overflow: 'hidden',
        padding: '0',
    };

    const pillPopperConfig = {
        modifiers: [{ name: 'offset', options: { offset: [skidding, 12] } }],
    };

    return (
      <>
        <style>{`
            .td-profile-menu .dropdown-header {
                background: #f3f4f6;
                color: #6e5f20;
                font-size: 10px;
                font-weight: 700;
                letter-spacing: 0.08em;
                text-transform: uppercase;
                padding: 8px 14px;
            }
            .td-profile-menu .dropdown-item {
                background: #ffffff;
                color: #1f2937;
                font-size: 13.5px;
                padding: 8px 14px;
                transition: background 150ms ease, color 150ms ease;
            }
            .td-profile-menu .dropdown-item:hover,
            .td-profile-menu .dropdown-item:focus {
                background: rgba(37, 99, 235, 0.10);
                color: #2563EB;
            }
            .td-profile-menu .dropdown-divider {
                border-color: #e5e7eb;
                margin: 2px 0;
            }
        `}</style>
        <Nav>
                <Dropdown as={NavItem} onClick={() => handleMenuClick()}>
                    <Dropdown.Toggle variant="link" bsPrefix="shadow-none" className="py-0 px-1 rounded-0 shadow-none border-0" id="dropdown-profile">
                        <div style={avatarStyle}>
                            <FontAwesomeIcon
                                id="rotated"
                                icon={faChevronDown}
                                style={{ color: '#C8B568', fontSize: '18px', fontWeight: 900, strokeWidth: 60, stroke: '#C8B568', transition: 'transform 0.3s ease' }}
                            />
                        </div>
                    </Dropdown.Toggle>
                {(() => {
                        if (accountProfile != null) {
                            return <Dropdown.Menu className="pt-0 td-profile-menu" style={dropdownMenuStyle} popperConfig={pillPopperConfig}>
                                        <Dropdown.Header className="rounded-top">Account</Dropdown.Header>
                                        {accountProfile.accountId !== "1" && (
                                            <>
                                                <Dropdown.Item onClick={() => handleMenuItemClick('account')}>
                                                    <ProfileDropdownItem icon={faBookmark}>Overview</ProfileDropdownItem>
                                                </Dropdown.Item>    
                                            </>
                                        )}
                                        <Dropdown.Item onClick={() => handleMenuItemClick('profile')}>
                                            <ProfileDropdownItem icon={faUser}>My Profile</ProfileDropdownItem>
                                        </Dropdown.Item>
                                        {accountProfile.accountId !== "1" && (
                                            <>        
                                                <Dropdown.Item onClick={() => handleMenuItemClick('companies')}>
                                                    <ProfileDropdownItem icon={faBuilding}>Companies</ProfileDropdownItem>
                                                </Dropdown.Item>
                                            </>
                                        )}

                                        {/* If account has docConversion role don't show Settings */}
                                        {!accountProfile.hasDocConversion && accountProfile.accountId !== "1" &&(
                                            <>
                                                <Dropdown.Header>Settings</Dropdown.Header>
                                                <Dropdown.Item onClick={() => handleMenuItemClick('settings')}>
                                                    <ProfileDropdownItem icon={faGear}>Settings</ProfileDropdownItem>
                                                </Dropdown.Item>
                                            </>
                                        )}

                                        {/* Add Dashboard section if the account has the impersonate role and is admin role*/}
                                        {accountProfile.hasImpersonate && (accountProfile.accountId === "1") && (
                                            <>
                                                <Dropdown.Header>Admin</Dropdown.Header>
                                                <Dropdown.Item onClick={() => handleMenuItemClick('admindashboard')}>
                                                    <ProfileDropdownItem icon={faClipboard}>Dashboard</ProfileDropdownItem>
                                                </Dropdown.Item>
                                            </>
                                        )}                                       

                                        {accountProfile.accountId !== "1" && (
                                            <>        
                                                <Dropdown.Header>About</Dropdown.Header>
                                                <Dropdown.Item onClick={() => handleMenuItemClick('contact')}>
                                                    <ProfileDropdownItem icon={faContactBook}>Contact</ProfileDropdownItem>
                                                </Dropdown.Item>              
                                            </>
                                        )}
                                        <Dropdown.Divider />

                                        {/* If account does not have impersonate role */}
                                        {!accountProfile.hasImpersonate && (
                                            <>
                                                <Dropdown.Item onClick={() => handleMenuItemClick('logout')}>
                                                    <ProfileDropdownItem icon={faPowerOff}>Logout</ProfileDropdownItem>
                                                </Dropdown.Item>  
                                            </>
                                        )} 

                                        {/* If account has impersonate role and is signed in to the admin test account */}
                                        {accountProfile.hasImpersonate && (accountProfile.accountId === "1") && (
                                            <>
                                                <Dropdown.Item onClick={() => handleMenuItemClick('logout')}>
                                                    <ProfileDropdownItem icon={faPowerOff}>Logout</ProfileDropdownItem>
                                                </Dropdown.Item>    
                                            </>
                                        )}  

                                        {/* If account has impersonate role and is not in admin test account*/}
                                        {accountProfile.hasImpersonate && (accountProfile.accountId !== "1") && (
                                            <>
                                                <Dropdown.Item onClick={() => handleMenuItemClick('log-up')}>
                                                    <ProfileDropdownItem icon={faPowerOff}>Log-up</ProfileDropdownItem>
                                                </Dropdown.Item>    
                                            </>
                                        )}    
                                    </Dropdown.Menu>
                        
                        } else {
                            return <Dropdown.Menu className="pt-0 td-profile-menu" style={dropdownMenuStyle} popperConfig={pillPopperConfig}>
                                        <Dropdown.Header className="rounded-top">Account</Dropdown.Header>
                                        <Dropdown.Item onClick={() => handleMenuItemClick('register')}>
                                            <ProfileDropdownItem icon={faLink}>Link to My Documents</ProfileDropdownItem>
                                        </Dropdown.Item>
                                        <Dropdown.Divider />
                                        <Dropdown.Item onClick={() => handleMenuItemClick('logout')}>
                                            <ProfileDropdownItem icon={faPowerOff}>Logout</ProfileDropdownItem>
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                        }
                })()}
            </Dropdown>        
        </Nav>
      </>
  )
}
